import { useResource } from 'app/common/api';
import { INotifications } from 'app/common/notifications/core/notifications';
import { TUserProfile } from 'app/railways/domains/profile/core';

import { TCredentials } from '../core';
import { loginRequest } from '../requests';

type UseSignInParams = {
  errorNotify: INotifications;
  onSuccess?: (profile: TUserProfile) => void;
};

export const useSignIn = ({ errorNotify, onSuccess }: UseSignInParams) => {
  const request = useResource<TCredentials, { user: TUserProfile }>({
    request: loginRequest,
    onAuthRequired: (error) => {
      // display erorr message for user
      // because server answer 401 error for invalid credentials
      errorNotify.addMessage({ message: error.message, type: 'error' });
    },
    errorNotify,
    onDone({ user }) {
      onSuccess?.(user);
    },
  });

  return request;
};
